import { render, staticRenderFns } from "./future-jobs.vue?vue&type=template&id=5155eaa8"
import script from "./future-jobs.vue?vue&type=script&lang=js"
export * from "./future-jobs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports